import * as React from 'react';

import withStyles, {
  WithStyles,
  StyleRulesCallback
} from '@material-ui/core/styles/withStyles';

import {
  Typography,
  Paper,
  Grid,
  Snackbar,
  CircularProgress,
  Button,
  IconButton
} from '@material-ui/core';

import BackIcon from '@material-ui/icons/ArrowBack';

import { withRouter, RouteComponentProps } from 'react-router-dom';

import {
  FarmLibraryProvider,
  LayoutToolsProvider,
  LayoutTools
} from '../providers';

import { DocumentCard, LinkButton } from '../components';
import { timestampToString } from '../utils';
import inferDocDownloadUrl from '../utils/inferDocDownloadUrl';
import SidePanel from './SidePanel';

type Props = WithStyles & RouteComponentProps<any>;

interface Renders {
  layout: LayoutTools;
  farmId: string;
  farm: Farm | null;
  documents: AnyDocument[] | null;
  loading: boolean;
  fetchMore: () => void;
  anythingLoading: boolean;
}

const styles: StyleRulesCallback = theme => ({
  root: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    height: '100vh'
  },
  list: {
    marginBottom: 30
  },
  badge: {
    width: '100%'
  },
  content: {
    padding: theme.spacing.unit * 3,
    flex: 1,
    overflowY: 'scroll',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    justifyContent: 'center'
  }
});

class Reports extends React.Component<Props> {
  renderDocument(doc: AnyDocument) {
    const downloadUrl = inferDocDownloadUrl(doc);
    return (
      <Grid key={doc.id} item={true} xs={12} sm={4}>
        <DocumentCard
          kind={(doc as ReportDocument).type}
          date={timestampToString(doc.createdOn)}
          selectable={false}
          onDownload={downloadUrl ? () => window.open(downloadUrl) : undefined}
        />
      </Grid>
    );
  }

  renderPanelItems(renders: Renders) {
    return (
      <>
        <div style={{display: 'flex'}}>
          <div style={{flex: 0, marginRight: 16, alignItems: 'center'}}>
            <IconButton onClick={() => this.props.history.goBack()}>
              <BackIcon />
            </IconButton>
          </div>
          <div style={{flex: 1}}>
            <Typography variant="subheading">Reportes</Typography>
            <Typography variant="headline">
              {renders.farm ? renders.farm.name : ''}
            </Typography>
          </div>
        </div>

        <Typography variant="subheading" style={{marginTop: 20}}>Crear reporte</Typography>

        <LinkButton
          fullWidth={true}
          variant="raised"
          to={`/reports/${renders.farmId}/create/tracking-field`}
          style={{ marginTop: '10px' }}
        >
          Seguimiento de lote
        </LinkButton>
        <LinkButton
          fullWidth={true}
          variant="raised"
          to={`/reports/${renders.farmId}/create/tracking-multiple-fields`}
          style={{ marginTop: '10px' }}
        >
          Seguimiento de múltiples lotes
        </LinkButton>
        <LinkButton
          fullWidth={true}
          variant="raised"
          to={`/reports/${renders.farmId}/create/raster`}
          style={{ marginTop: '10px' }}
        >
          Raster individual
        </LinkButton>
        <LinkButton
          fullWidth={true}
          variant="raised"
          to={`/reports/${renders.farmId}/create/raster-zone`}
          style={{ marginTop: '10px' }}
        >
          Raster por zona de gestión
        </LinkButton>
        <LinkButton
          fullWidth={true}
          variant="raised"
          to={`/reports/${renders.farmId}/create/raster-zone`}
          style={{ marginTop: '10px' }}
        >
          Comparación de rasters
        </LinkButton>
      </>
    );
  }

  renderLoading(renders: Renders) {
    return (
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={renders.anythingLoading}
        message={
          <>
            <CircularProgress color="secondary" size={25} />
            <span>cargando</span>
          </>
        }
      />
    );
  }

  renderFetchMoreButton(renders: Renders) {
    return (
      <Grid item={true} xs={12} style={{ textAlign: 'center', marginTop: 10 }}>
        <Button onClick={renders.fetchMore} disabled={renders.anythingLoading}>
          Cargar Más
        </Button>
      </Grid>
    );
  }

  composeProviders(children: (renders: Renders) => React.ReactNode) {
    const {
      match: {
        params: { farmId }
      }
    } = this.props;

    return (
      <LayoutToolsProvider>
        {layout => (
          <FarmLibraryProvider
            farmId={farmId}
            first={9}
            filter={{ kind: ['report'] }}
          >
            {result => (
                children({
                  farmId,
                  layout,
                  farm: result.farm,
                  documents: result.documents,
                  loading: result.loading,
                  fetchMore: result.fetchMore,
                  anythingLoading: result.loading
                })
            )}
          </FarmLibraryProvider>
        )}
      </LayoutToolsProvider>
    );
  }

  render() {
    const { classes } = this.props;

    return this.composeProviders(renders => (
      <main className={classes.root}>
        <SidePanel>{this.renderPanelItems(renders)}</SidePanel>
        <Paper square={true} elevation={1} className={classes.content}>
          <Grid container={true} spacing={24} style={{ maxWidth: 900 }}>
            {this.renderLoading(renders)}
            {renders.documents &&
              renders.documents.map(doc => this.renderDocument(doc))}
            {renders.documents && this.renderFetchMoreButton(renders)}
          </Grid>
        </Paper>
      </main>
    ));
  }
}

export default withStyles(styles)(withRouter(Reports));



// WEBPACK FOOTER //
// ./src/containers/Reports.tsx